import { render, staticRenderFns } from "./loader-table.vue?vue&type=template&id=27caa2f8&"
import script from "./loader-table.vue?vue&type=script&lang=js&"
export * from "./loader-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports